export const GAIN_SETTINGS = 'gain-settings';
export const AGC_GAIN_CAPS_PREFIX = 'agc-gain-caps';
export const OSC_MIT_GAIN_PREFIX = 'osc-mit-default-gain';
export const AGC_DURATION_PREFIX = 'du-rx-agc';
export const networkElements = ['DU', 'SU1', 'SU2', 'SU3', 'SU4'];
export const agcGainCapsPropNames = ['rx-hpol-db', 'rx-vpol-db', 'tx-hpol-db', 'tx-vpol-db'];
export const oscMitGainsPropNames = ['du-tx-db', 'su-rx-db', 'su-tx-db'];
export const agcDurationPropNames = ['duration-seconds'];

const agcGainCapsNames = agcGainCapsPropNames.map((name) => `${AGC_GAIN_CAPS_PREFIX}-${name}`);
const oscMitGainsNames = oscMitGainsPropNames.map((name) => `${OSC_MIT_GAIN_PREFIX}-${name}`);
const agcDurationNames = agcDurationPropNames.map((name) => `${AGC_DURATION_PREFIX}-${name}`);

export const defaultProperties = networkElements.reduce((acc, networkElement, index) => {
  const propNames = index === 0 ? [...agcGainCapsNames, ...oscMitGainsNames, ...agcDurationNames] : agcGainCapsNames;
  const gainSettings = propNames.reduce((acc, propName) => {
    acc[propName] = undefined;

    return acc;
  }, {});

  acc[networkElement] = {
    [GAIN_SETTINGS]: gainSettings
  };

  return acc;
}, {});
